import React from 'react';

import './card.scss';

const Card = ({ title, value, label }) => {
  return (
    <div className="billing-payments-card">
      <div className="title">{title}</div>
      <div className="value">{value}</div>
      {label && <span className={`label label-${label.toLowerCase()}`}>{label}</span>}
    </div>
  );
};

export default Card;
